import React from 'react';
import styles from 'components/ListItemCountLabel.css';

const ListItemCountLabel = ({ itemCount, itemTypes }) =>
  <div className={styles.container}>
    <span className={styles.itemCount}>
      {itemCount}
    </span>
    <span className={styles.itemTypes}>
      {itemTypes}
    </span>
  </div>;

export default ListItemCountLabel;
